import { render, staticRenderFns } from "./EnrolleeSlip.vue?vue&type=template&id=2f6f133e&scoped=true&"
import script from "./EnrolleeSlip.vue?vue&type=script&lang=js&"
export * from "./EnrolleeSlip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6f133e",
  null
  
)

export default component.exports